import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type QueuePatientFragmentFragment = { readonly __typename?: 'PatientOfQueue', readonly uuid: string, readonly fullname: string, readonly gender: Types.Gender, readonly addedAt: string, readonly triageStatus?: { readonly __typename?: 'TriageStatusOfQueue', readonly _id: string, readonly currentStatus?: string | null, readonly expiresAt?: string | null, readonly createdAt?: string | null, readonly updatedAt?: string | null } | null };

export type GetClinicQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetClinicQuery = { readonly __typename?: 'Query', readonly clinic?: { readonly __typename?: 'Clinic', readonly uuid: string, readonly name: string } | null };

export type CreatePatientQueueMutationVariables = Types.Exact<{
  input: Types.CreatePatientQueueInput;
}>;


export type CreatePatientQueueMutation = { readonly __typename?: 'Mutation', readonly createPatientQueue: { readonly __typename?: 'PatientQueue', readonly _id: string, readonly name: string, readonly patients: ReadonlyArray<{ readonly __typename?: 'PatientOfQueue', readonly uuid: string, readonly fullname: string, readonly gender: Types.Gender, readonly addedAt: string, readonly triageStatus?: { readonly __typename?: 'TriageStatusOfQueue', readonly _id: string, readonly currentStatus?: string | null, readonly expiresAt?: string | null, readonly createdAt?: string | null, readonly updatedAt?: string | null } | null } | null> } };

export type GetFacilityQueuesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetFacilityQueuesQuery = { readonly __typename?: 'Query', readonly facilityQueues: ReadonlyArray<{ readonly __typename?: 'PatientQueue', readonly _id: string, readonly name: string, readonly patients: ReadonlyArray<{ readonly __typename?: 'PatientOfQueue', readonly uuid: string, readonly fullname: string, readonly gender: Types.Gender, readonly addedAt: string, readonly triageStatus?: { readonly __typename?: 'TriageStatusOfQueue', readonly _id: string, readonly currentStatus?: string | null, readonly expiresAt?: string | null, readonly createdAt?: string | null, readonly updatedAt?: string | null } | null } | null> } | null> };

export type GetPatientQueueQueryVariables = Types.Exact<{
  input: Types.FacilityQueueInput;
}>;


export type GetPatientQueueQuery = { readonly __typename?: 'Query', readonly facilityQueue?: { readonly __typename?: 'PatientQueue', readonly _id: string, readonly name: string, readonly patients: ReadonlyArray<{ readonly __typename?: 'PatientOfQueue', readonly uuid: string, readonly fullname: string, readonly gender: Types.Gender, readonly addedAt: string, readonly triageStatus?: { readonly __typename?: 'TriageStatusOfQueue', readonly _id: string, readonly currentStatus?: string | null, readonly expiresAt?: string | null, readonly createdAt?: string | null, readonly updatedAt?: string | null } | null } | null> } | null };

export type DeletePatientQueueMutationVariables = Types.Exact<{
  input: Types.DeletePatientQueueInput;
}>;


export type DeletePatientQueueMutation = { readonly __typename?: 'Mutation', readonly deletePatientQueue: { readonly __typename?: 'PatientQueueDeleteResult', readonly _id: string, readonly deletionSuccess: boolean, readonly message?: string | null } };

export const QueuePatientFragmentFragmentDoc = gql`
    fragment QueuePatientFragment on PatientOfQueue {
  uuid
  fullname
  gender
  addedAt
  triageStatus {
    _id
    currentStatus
    expiresAt
    createdAt
    updatedAt
  }
}
    `;
export const GetClinicDocument = gql`
    query getClinic($id: String!) {
  clinic(id: $id) {
    uuid
    name
  }
}
    `;

/**
 * __useGetClinicQuery__
 *
 * To run a query within a React component, call `useGetClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClinicQuery(baseOptions: Apollo.QueryHookOptions<GetClinicQuery, GetClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicQuery, GetClinicQueryVariables>(GetClinicDocument, options);
      }
export function useGetClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicQuery, GetClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicQuery, GetClinicQueryVariables>(GetClinicDocument, options);
        }
export type GetClinicQueryHookResult = ReturnType<typeof useGetClinicQuery>;
export type GetClinicLazyQueryHookResult = ReturnType<typeof useGetClinicLazyQuery>;
export type GetClinicQueryResult = Apollo.QueryResult<GetClinicQuery, GetClinicQueryVariables>;
export const CreatePatientQueueDocument = gql`
    mutation CreatePatientQueue($input: CreatePatientQueueInput!) {
  createPatientQueue(input: $input) {
    _id
    name
    patients {
      ...QueuePatientFragment
    }
  }
}
    ${QueuePatientFragmentFragmentDoc}`;
export type CreatePatientQueueMutationFn = Apollo.MutationFunction<CreatePatientQueueMutation, CreatePatientQueueMutationVariables>;

/**
 * __useCreatePatientQueueMutation__
 *
 * To run a mutation, you first call `useCreatePatientQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientQueueMutation, { data, loading, error }] = useCreatePatientQueueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePatientQueueMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatientQueueMutation, CreatePatientQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePatientQueueMutation, CreatePatientQueueMutationVariables>(CreatePatientQueueDocument, options);
      }
export type CreatePatientQueueMutationHookResult = ReturnType<typeof useCreatePatientQueueMutation>;
export type CreatePatientQueueMutationResult = Apollo.MutationResult<CreatePatientQueueMutation>;
export type CreatePatientQueueMutationOptions = Apollo.BaseMutationOptions<CreatePatientQueueMutation, CreatePatientQueueMutationVariables>;
export const GetFacilityQueuesDocument = gql`
    query getFacilityQueues {
  facilityQueues {
    _id
    name
    patients {
      ...QueuePatientFragment
    }
  }
}
    ${QueuePatientFragmentFragmentDoc}`;

/**
 * __useGetFacilityQueuesQuery__
 *
 * To run a query within a React component, call `useGetFacilityQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacilityQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacilityQueuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFacilityQueuesQuery(baseOptions?: Apollo.QueryHookOptions<GetFacilityQueuesQuery, GetFacilityQueuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFacilityQueuesQuery, GetFacilityQueuesQueryVariables>(GetFacilityQueuesDocument, options);
      }
export function useGetFacilityQueuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFacilityQueuesQuery, GetFacilityQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFacilityQueuesQuery, GetFacilityQueuesQueryVariables>(GetFacilityQueuesDocument, options);
        }
export type GetFacilityQueuesQueryHookResult = ReturnType<typeof useGetFacilityQueuesQuery>;
export type GetFacilityQueuesLazyQueryHookResult = ReturnType<typeof useGetFacilityQueuesLazyQuery>;
export type GetFacilityQueuesQueryResult = Apollo.QueryResult<GetFacilityQueuesQuery, GetFacilityQueuesQueryVariables>;
export const GetPatientQueueDocument = gql`
    query getPatientQueue($input: FacilityQueueInput!) {
  facilityQueue(input: $input) {
    _id
    name
    patients {
      ...QueuePatientFragment
    }
  }
}
    ${QueuePatientFragmentFragmentDoc}`;

/**
 * __useGetPatientQueueQuery__
 *
 * To run a query within a React component, call `useGetPatientQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientQueueQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPatientQueueQuery(baseOptions: Apollo.QueryHookOptions<GetPatientQueueQuery, GetPatientQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientQueueQuery, GetPatientQueueQueryVariables>(GetPatientQueueDocument, options);
      }
export function useGetPatientQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientQueueQuery, GetPatientQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientQueueQuery, GetPatientQueueQueryVariables>(GetPatientQueueDocument, options);
        }
export type GetPatientQueueQueryHookResult = ReturnType<typeof useGetPatientQueueQuery>;
export type GetPatientQueueLazyQueryHookResult = ReturnType<typeof useGetPatientQueueLazyQuery>;
export type GetPatientQueueQueryResult = Apollo.QueryResult<GetPatientQueueQuery, GetPatientQueueQueryVariables>;
export const DeletePatientQueueDocument = gql`
    mutation DeletePatientQueue($input: DeletePatientQueueInput!) {
  deletePatientQueue(input: $input) {
    _id
    deletionSuccess
    message
  }
}
    `;
export type DeletePatientQueueMutationFn = Apollo.MutationFunction<DeletePatientQueueMutation, DeletePatientQueueMutationVariables>;

/**
 * __useDeletePatientQueueMutation__
 *
 * To run a mutation, you first call `useDeletePatientQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePatientQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePatientQueueMutation, { data, loading, error }] = useDeletePatientQueueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePatientQueueMutation(baseOptions?: Apollo.MutationHookOptions<DeletePatientQueueMutation, DeletePatientQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePatientQueueMutation, DeletePatientQueueMutationVariables>(DeletePatientQueueDocument, options);
      }
export type DeletePatientQueueMutationHookResult = ReturnType<typeof useDeletePatientQueueMutation>;
export type DeletePatientQueueMutationResult = Apollo.MutationResult<DeletePatientQueueMutation>;
export type DeletePatientQueueMutationOptions = Apollo.BaseMutationOptions<DeletePatientQueueMutation, DeletePatientQueueMutationVariables>;